export default (state, action) => {
    switch (action.type) {
        case 'INTERVENTION_CLICK':
            if (action.data && action.data.reset) {
                return null;
            }
            return Object.assign({}, { data: action.data, userId: action.userId, itemId: action.itemId });
        default:
            return state || null;
    }
};
